<template>
  <div>
    <section class="hero is-fullheight">
      <div class="hero-body is-primary">
        <div class="container has-text-centered">
          <h1 class="subtitle is-1 is-hidden-mobile">
            {{tituloPrimeraLinea}}
            <br />
            {{tituloSegundaLinea}}
          </h1>
          <h1 class="subtitle is-3 is-hidden-tablet">
            {{tituloPrimeraLinea}}
            <br />
            {{tituloSegundaLinea}}
          </h1>
          <b-button
            class="boton-productos is-hidden-mobile"
            type="is-primary"
            size="is-large"
            tag="a"
            href="#"
            v-scroll-to="'#seccion-productos'"
          >¡SUBÍ TUS FOTOS!</b-button>
          <b-button
            class="boton-productos is-hidden-tablet"
            type="is-primary"
            size="is-medium"
            tag="a"
            href="#"
            v-scroll-to="'#seccion-productos'"
          >¡SUBÍ TUS FOTOS!</b-button>
        </div>
      </div>
    </section>
    <!-- <section class="section has-text-centered is-hidden-tablet">
      <div class="titulo-mobile">
        <div class="title">{{tituloPrimeraLinea}}</div>
        <div class="subtitle">{{tituloSegundaLinea}}</div>
        <div class="is-divider is-secundary"></div>
      </div>
    </section> -->
    <Productos id="seccion-productos" />
    <WhatsappFlotante />
  </div>
</template>

<style lang="scss" scoped>
.titulo-mobile {
  margin-top: 1.3rem;
  margin-bottom: -4rem;
}
@keyframes kreep {
  0% {
    -webkit-transform: scale(1.1, 0.9);
    transform: scale(1.1, 0.9);
  }
  50% {
    -webkit-transform: scale(0.9, 1.1) translateY(-0.5rem);
  }
  70% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
.hero {
  background-image: url('~@/assets/img/productos/subir-fotos.jpg');
  background: linear-gradient(rgba(31, 44, 108, 0), rgba(31, 44, 108, 0)), rgba(0, 0, 0, 0) url("~@/assets/img/productos/subir-fotos.jpg") no-repeat;
  background-attachment: fixed;
  background-size: cover;
  // background-position: center;
  background-position-x: 50%; // Solucion para ios en vez de background-position: center
  background-position-y: 0%; // Solucion para ios en vez de background-position: center
}

.boton-productos {
  margin: 0.3rem;
  display: inline-block;
  /*name-duration-function(ease,eas-in,linear)-delay-count-direction */
  animation: kreep 0.7s ease 2s infinite alternate;
}
.boton-productos:hover {
  animation: none;
}
</style>

<script>
import Productos from '@/components/Productos/Productos.vue'
import WhatsappFlotante from '@/components/WhatsappFlotante.vue'

export default {
  name: 'SubirFotosGeneral',
  data () {
    return {
      tituloPrimeraLinea: 'IMPRIMÍ TUS FOTOS',
      tituloSegundaLinea: 'EN POCOS CLICS',
      textoBoton: 'Hace clic aquí'
    }
  },
  components: {
    Productos,
    WhatsappFlotante
  }
}
</script>
